import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,

} from './styles';



import { useAuth } from '../../hooks/Auth';

import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';

import api from '../../services/api';
import { hash, urlWebsite } from '../../config';

import { loadFromJson } from '../../utils/loadFromJson';
import LeiteEmPo from '../ComoEFeito/modules/LeiteEmPo';

interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const DesempenhoMaximo: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const data = [

    { img_style: { width: '70px', margin: '0px 15px' }, icon: '/apoio/recuperacao.png', title: 'RECUPERAÇÃO MUSCULAR', description: 'Cada porção do novo leite em pó CCGL contém uma dose concentrada de proteínas de alta qualidade, projetada para acelerar a recuperação muscular após cada treino intenso. Os aminoácidos essenciais presentes garantem uma reparação celular eficaz, permitindo que seus músculos se recuperem mais rapidamente para enfrentar os desafios seguintes.' },
    { img_style: { width: '90px', margin: '0px 5px' }, icon: '/apoio/ganho-muscular.png', title: 'GANHO MUSCULAR', description: 'Não se trata apenas de recuperação, mas também de crescimento. Com 12 gramas de proteína por porção, nosso leite em pó fornece o combustível necessário para auxiliar o seu desenvolvimento muscular após exercício físico.' },
    { img_style: { width: '90px', margin: '0px 5px' }, icon: '/apoio/articular.png', title: 'SAÚDE ARTICULAR', description: 'Combinamos os benefícios da proteína com nutrientes essenciais para a saúde óssea e articular (vitamina D, cálcio, magnésio), proporcionando uma fundação robusta para suportar o impacto de treinos intensos. Fortaleça seus ossos e articulações, garantindo sua jornada de condicionamento físico.' },

  ]
  const currentData = data?.[currentIndex] || {};

  return (<>
    <img src="/apoio/cabecalho-leite.png" style={{ width: '100%', zIndex: 10000 }} />


    <Container className='gap-bg column  ' style={{ minHeight: '80vh', background: 'none', zIndex: 900 }}>
      <div className='row full-width fadeIn '>  <LeiteEmPo style={{ textAlign: 'center' }} />
      </div>
      <div className='max-1000 gap-bg column fadeIn '>
        <img loading='lazy' src='/apoio/pro/imagens-pagina3.png' className='max-1000 computerOnly' />

        <img loading='lazy' src='/apoio/pro/pag3-mobile.png' className='max-1000 mobileOnly' />


        <p className='contentParagraphSimple fadeIn  column max-1000 gap-sm'>
          <strong className='background2 pad-sm color1' style={{ width: '100%' }}  >PARA QUEM AMA FAZER EXERCÍCIOS E TEM FOCO NO DESEMPENHO MÁXIMO – GANHO DE MASSA MUSCULAR</strong>
          <p className=' pad-sm' style={{ textAlign: 'left' }}> Para você que pratica exercícios e busca ganho muscular, o leite em pó proteico CCGL é uma fonte poderosa com 12 gramas de proteína por porção, enriquecido com nutrientes essenciais para impulsionar seu desempenho atlético a novos patamares. </p></p>


        <div className='column computerOnlyFlex'>

          {data?.map(item => {
            return <div className='row fadeIn   row-start row-to-column max-1000 gap-md pad-sm'>
              <img loading='lazy' className='max-100' style={{ ...item?.img_style }} src={item?.icon} />
              <p className='contentParagraphSimple text-left max-1000'>
                <strong className='color2'>{item?.title}</strong> <br />
                <p  > {item?.description}</p></p>
            </div>


          })}

        </div>

        <div className='mobileOnlyFlex column'>

          <div className='row gap-xs'>

            {data?.map((item, index) => {

              return <div style={{ borderRadius: '7.5px', width: '60px', height: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className={`pad-xs fadeIn  ${index === currentIndex ? 'background1 ' : 'none'}`}>
                <img loading='lazy' onClick={() => setCurrentIndex(index)} style={{ maxHeight: '50px', width: 'auto' }} src={item?.icon} /></div>
            })}


          </div>

          <div key={currentData?.title} className='row fadeIn  row-start rcolumn max-1000 gap-md pad-sm'>
            <p className='contentParagraphSimple text-left max-1000'>
              <strong className='color2'>{currentData?.title}</strong> <br />
              <p  > {currentData?.description}</p></p>
          </div>


        </div>

        <div className='separadorLp' />

        <div className='column'>
          <p className=' pad-sm colorWhite max-1000'  > Escolha mais do que uma bebida. Escolha uma parceria na sua jornada de exercícios físicos. Elevando seu desempenho, nutrindo seu corpo e alimentando sua determinação. Desperte o atleta em você com nosso</p>

          <p className=' pad-sm colorWhite  max-1000' > <strong className='color2'>SEU SUCESSO COMEÇA COM O PRIMEIRO GOLE!</strong></p>
        </div> </div>



    </Container>

  </>
  );
};
export default DesempenhoMaximo;
